define('drops/requirementsGraph/requirementsGraph',[
    'jquery',
    'underscore',
    'lq/drop',
    'drops/requirementsGraph/requirementsgraphimpl',
    'drops/requirementsGraph/barvalue',
    'lq/style'
], function ($, _, Drop, RequirementsGraphImpl, BarValue, Style) {
    'use strict';

    function RequirementsGraph(options) {
        Drop.call(this, $('<div/>'), options);

        this.data.styles = this.data.styleId;

        var $container = $('<div />')
            .addClass('requirementsGraphContainer')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);

        this.graph = new RequirementsGraphImpl($container[0]);
        this.limits = [];
        this.planningUnits = [];
        this.scheduleUnits = [];
        this.barValues = [];

        this.$element
            .addClass('boxToBorderSize');

        Style.renderStyles(this, 'requirementgraph-', $container);
    };

    Drop.extend(RequirementsGraph, Drop);

    RequirementsGraph.typeName = 'RequirementsGraph';
        
    RequirementsGraph.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    RequirementsGraph.prototype.licquidMethod_load = function () {
        var self = this;
        if (this.data.isWithPreferredValues) {
            this.piping.queryDispatcher.dispatch(
                this.data.selectedScheduleDataSource,
                function (data) {
                    self.scheduleUnits = data.Results;

                    self.piping.queryDispatcher.dispatch(
                        self.data.selectedLimitsDataSource,
                        function (data) {
                            self.limits = data.Results;
                            self.mergeData();
                        },
                        function (queryData) {
                            queryData.pageSize = 1024;
                        });

                    self.piping.queryDispatcher.dispatch(
                        self.data.selectedPlanningDataSource,
                        function (data) {
                            self.planningUnits = data.Results;
                            self.mergeData();
                        },
                        function (queryData) {
                            queryData.pageSize = 1024;
                        });
                },
                function (queryData) {
                    queryData.pageSize = 1024;
                });
        } else {
            this.piping.queryDispatcher.dispatch(
                this.data.selectedPlanningDataSource,
                function (data) {
                    self.planningUnits = data.Results;

                    self.piping.queryDispatcher.dispatch(
                        self.data.selectedLimitsDataSource,
                        function (data) {
                            self.limits = data.Results;
                            self.mergeData();
                        }, function (queryData) {
                            queryData.pageSize = 1024;
                        });
                }, function (queryData) {
                    queryData.pageSize = 1024;
                });
        }
    };

    RequirementsGraph.prototype.mergeData = function () {
        var self = this;

        if (self.limits.length > 0 && self.planningUnits != undefined && (self.data.isWithPreferredValues ? self.scheduleUnits != undefined : true)) {
            if (self.limits.length > 1) {
                alert('Multiple axis-limits found, only using first.');//TODO JHU: handle too much limits
            }

            self.data.xAxisMin = self.limits[0][self.data.xAxisMinOutput];
            self.data.xAxisMax = self.limits[0][self.data.xAxisMaxOutput];

            self.barValues = [];

            var quarter = self.data.xAxisSubInterval;
            var barUnit = 0;
            while (barUnit < self.data.xAxisInterval * 24) {
                var scheduledAmount = 0;
                var planningUnit = _.find(self.planningUnits, function (unit) { return unit[self.data.xValueOutput] == barUnit; });
                _.each(self.scheduleUnits, function(scheduleUnit) {
                    if (scheduleUnit[self.data.xValueStartOutput] <= barUnit && scheduleUnit[self.data.xValueStopOutput] > barUnit) {
                        scheduledAmount++;
                    }
                });
                var plannedAmount = planningUnit == undefined ? 0 : parseInt(planningUnit[self.data.yValueOutput]);
                var planningId = planningUnit == undefined ? 0 : planningUnit[self.data.barIdOutput];
                var barval = new BarValue(planningId, barUnit, plannedAmount, scheduledAmount);
                self.barValues.push(barval);
                barUnit += quarter;
            }
                
            self.graph.draw(self.retrieveRequirementsGraphData());
        }
    };
        
    RequirementsGraph.prototype.convertToNumber = function (string) {
        if (typeof string === 'number') {
            return string;
        } else {
            return parseFloat(string);
        }
    };

    RequirementsGraph.prototype.convertToBoolean = function (string) {
        if (typeof string === 'boolean') {
            return string;
        } else {
            return string === 'true';
        }
    };

    RequirementsGraph.prototype.retrieveRequirementsGraphData = function () {
        var maxY = this.convertToNumber(this.data.yAxisTo);

        var self = this;
        this.barValues.forEach(function (bar) {
            if (self.convertToNumber(bar.preferredValue) >= maxY) maxY = self.convertToNumber(bar.preferredValue) + 1;
            if (self.convertToNumber(bar.selectedValue) >= maxY) maxY = self.convertToNumber(bar.selectedValue) + 1;
        });


        return {
            readOnly: this.data.readOnly,

            xAxisLabel: this.data.xAxisLabel,
            xAxisFrom: this.convertToNumber(this.data.xAxisFrom),
            xAxisTo: this.convertToNumber(this.data.xAxisTo),
            xAxisInterval: this.convertToNumber(this.data.xAxisInterval),
            xAxisSubInterval: this.convertToNumber(this.data.xAxisSubInterval),
            xAxisMin: this.convertToNumber(this.data.xAxisMin),
            xAxisMax: this.convertToNumber(this.data.xAxisMax),
            xAxisShowAsTime: this.convertToBoolean(this.data.xAxisShowAsTime),

            yAxisLabel: this.data.yAxisLabel,
            yAxisFrom: this.convertToNumber(this.data.yAxisFrom),
            yAxisTo: maxY,
            yAxisInterval: this.convertToNumber(this.data.yAxisInterval),
            yAxisSubInterval: this.convertToNumber(this.data.yAxisSubInterval),
            yAxisShowAsTime: this.convertToBoolean(this.data.yAxisShowAsTime),

            showAxisLabels: this.convertToBoolean(this.data.showAxisLabels),
            isWithPreferredValues: this.convertToBoolean(this.data.isWithPreferredValues),

            barValues: this.barValues
        };
    };

    RequirementsGraph.prototype.getBatchOfCommands = function () {
        if (!this.graph) return [];
        if (!this.data.parentIdParameter) return [];

        var parentId = this.piping.parameters.getValue(this.data.parentIdParameter);

        var self = this;
        return {
            eventActionType: 'Batch',
            command: this.data.id,
            batch: _.map(this.graph.getBarValues(), function (barValue) {
                var data = {};
                data[self.data.xValueAttribute] = barValue.xValue;
                data[self.data.yValueAttribute] = barValue.selectedValue;
                data[self.data.parentIdAttribute] = parentId;

                return {
                    entityId: barValue.id ? barValue.id : null,
                    data: data
                };
            })
        };

    };

    return RequirementsGraph;
});
